<template>
    <div class="search">
        <input
            type="text"
            v-model="searchQuery"
            placeholder="Buscar banco"
            @input="filterBanks"
            class="search__input"
        />
        <button class="search__button" @click="filterBanks" tabindex="0">
            <img
                src="@/assets/img/Search.svg"
                alt="icone de pesquisa"
                class="search__icon"
                tabindex="-1"
            />
        </button>
    </div>
</template>

<script>
export default {
	data() {
		return {
			searchQuery: '',
		};
	},
	methods: {
		filterBanks() {
			this.$emit('filter', this.searchQuery);
		}
	}
};
</script>

<style lang="scss" scoped>
.search {
	position: relative;
	display: flex;
	align-items: center;

	margin-bottom: 32px;

	&__input {
		width: 100%;
		max-width: 580px;
		height: 44px;
		border: 1.5px solid #B8C1CC;
		border-radius: 1000px;
		padding-left: 16px;

		font-size: 16px;
		font-weight: 500;
		line-height: 24px;
	}

	&__button {
		position:absolute;
		right: 16px;
		background: none;
		border: none;
	}
}
</style>

